import { RcClasses } from '../../../../foundation';
export var RcTableCellClasses = RcClasses([
    'head',
    'body',
    'sortIcon',
    'activeSort',
    'sortButton',
    'paddingCheckbox',
    'paddingNone',
], 'RcTableCell');
